const CONFIG_STORAGE_KEY = 'xaikus_roulette_config';

const defaultConfiguration = {
  logo: null,
  logoPosition: { x: 50, y: 50 },
  colors: {
    primary: '#1E40AF',
    secondary: '#3B82F6'
  },
  texts: {
    mainTitle: '¡Gira y Gana con XAIKUS!',
    welcomeMessage: 'Participa y descubre tu premio',
    medicalMessage: 'XAIKUS - Innovación en salud cardiovascular, urológica y respiratoria'
  },
  prizes: [
    { id: 6, name: '15 Stickers / Vale $10', probability: 15, color: '#F97316', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.20.04_PM_1_-1775960658804.jpeg' },
    { id: 7, name: '45 Stickers / Vale $30', probability: 10, color: '#EC4899', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.20.04_PM_2_-1775960982304.jpeg' },
    { id: 8, name: 'Camiseta Argentina', probability: 5, color: '#75AADB', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.20.04_PM-1775961243039.jpeg' },
    { id: 9, name: 'Balón Xaikus', probability: 5, color: '#F59E0B', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.21.30_PM_1_-1775961400324.jpeg' },
    { id: 10, name: 'Balón FIFA 2026', probability: 5, color: '#C0392B', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.21.30_PM-1775961476697.jpeg' },
    { id: 11, name: 'Quiniela Mundialista', probability: 5, color: '#1D6A2B', enabled: true, image: '/assets/images/WhatsApp_Image_2026-04-11_at_9.21.31_PM_1_-1775961552393.jpeg' }
  ],
  backgroundImage: null,
  orientation: 'auto',
  autoAdjustBackground: true,
  backgroundBlur: false,
  animationSpeed: 'medium',
  soundEnabled: true,
  victorySoundEnabled: true,
  celebrationAnimation: true,
  spinParticles: false,
  hapticFeedback: false,
  kioskMode: false,
  autoFullscreen: false,
  preventSleep: true
};

export const saveConfiguration = (config) => {
  try {
    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));
    return true;
  } catch (error) {
    console.error('Error saving configuration:', error);
    return false;
  }
};

export const loadConfiguration = () => {
  try {
    const saved = localStorage.getItem(CONFIG_STORAGE_KEY);
    if (saved) {
      return JSON.parse(saved);
    }
    return defaultConfiguration;
  } catch (error) {
    console.error('Error loading configuration:', error);
    return defaultConfiguration;
  }
};

export const resetConfiguration = () => {
  try {
    localStorage.removeItem(CONFIG_STORAGE_KEY);
    return defaultConfiguration;
  } catch (error) {
    console.error('Error resetting configuration:', error);
    return defaultConfiguration;
  }
};

export { defaultConfiguration };
